import axios from "@/CommonDP/utils/request";

export function getDataListByMeta(data, params) {
  return axios({
    method: 'post',
    url: `/dyn-common/getDataListByMeta`,
    data, params
  });
}
